import { Fab, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'

const StyledFab = styled(Fab)((props) => ({
    width: '100% !important',
    textTransform: 'capitalize',
    fontSize: '14px',
    height: '31px !important',
    margin: '8px 0px !important',
    backgroundColor: '#01ae8f ',
    color: '#ffffff',
    boxShadow: 'none',
    border: '1px solid transparent',
    overflowWrap: 'anywhere',
    lineHeight: 0,

    '& svg': {
        position: 'absolute',
        right: '12px',
        top: '50%',
        transform: 'translateY(-50%)',
    },
    '&:hover': {
        backgroundColor: '#01ae8f ',
    },
    ...props.styles,
    '&.Mui-disabled': {
        backgroundColor: '#f7f8fa !important',
        border: '1px solid #8b909a !important',

        color: '#8b909a !important',
        '& svg': {
            color: '#8b909a',
        },
    },
}))

const AddButton = ({
    styles,
    active,
    iconName,
    startIcon,
    children,
    activeStyle,
    ...rest
}) => {
    return (
        <StyledFab variant="extended" size="small" styles={styles} {...rest}>
            {startIcon && (
                <Icon
                    name={iconName ? iconName : 'ArrowSmall'}
                    color={styles?.color ? styles.color : '#ffffff'}
                ></Icon>
            )}
            {children}

            {!startIcon && (
                <Icon
                    name={iconName ? iconName : 'ArrowSmall'}
                    color={styles?.color ? styles.color : '#ffffff'}
                ></Icon>
            )}
        </StyledFab>
    )
}

export default AddButton
